<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/doubleRandom_banner.png');">
          <div class="banner_item1_content">
            <p>“双随机，一公开”监督执法系统</p>
            <p class="txt1">
              创新监管方式，加强事中事后监管，规范执法行为 实现互联网+
              监督执法模式的转变，
            </p>
            <div class="item1_infoBox">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案背景</span>
          <span>全面推开将为科学高效监管提供新思路</span>
        </div>
        <div class="part1_section">
          <div>
            <span>“双随机、一公开”消防监管总体要求</span>
            <span></span>
            <span>为深化消防执法改革，落实《国务院关于在市场监管领域全面推行部门联合“双随机、一公开”监管的意见》（国发〔2019〕5号）的部署要求，创新监管方式，加强事中事后监管，规范执法行为，需在全国消防救援队伍统一建设、分级应用“双随机、一公开”消防监管信息系统，以适应新的消防监督检查流程</span>
          </div>
          <div>
            <img src="static/image/double_part1bg.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part2_content">
        <div class="part2_header">
          <span class="part2_header_txt1">方案简介</span>
          <span class="part2_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part2_header_txt3">系统基于互联网建设，坚持公开透明，实行“智慧消防”、“阳光消防”，通过消防微信公众号系统对随机抽查事项、程序和结果进行实时动态的公开，接收社会和民众的监督，真正解决执法检查随意性大、检查深度不够和隐患排查不见底等问题，避免“任性执法”。标志着消防由传统监督执法模式走向互联网+监督执法模式的转变！</span>
        </div>
        <div>
          <img src="static/image/double_part2bg.png" alt="">
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part3_content">
        <div class="part2_header">
          <span class="part2_header_txt1">解决方案</span>
          <span class="part2_header_txt2">全面推开将为科学高效监管提供新思路</span>
        </div>
        <div class="part3_tabs">
          <div class="part3_tab1" :class="{'activeTab':isActive == 1}" @click="handleClick(1)">
            数据初始导入--“一单”
            <span class="activeLine" v-show="isActive == 1"></span>
          </div>
          <div class="part3_tab1" :class="{'activeTab':isActive == 2}" @click="handleClick(2)">
            数据初始导入--“两库”
            <span class="activeLine" v-show="isActive == 2"></span>
          </div>
          <div class="part3_tab1" :class="{'activeTab':isActive == 3}" @click="handleClick(3)">
            数据初始导入--“一细则”
            <span class="activeLine" v-show="isActive == 3"></span>
          </div>
        </div>
        <div>
          <div class="part3_tab_content" v-show="isActive == 1">
            <div>
              <div class="part3_tab_contentTxt1">
                “一单”是指消防监督随机抽查事例清单。事例清单明确抽查依据主体、对象、比例、内容、方式等内容。
              </div>
              <div>
                <span class="part3_tab_contentTxt2">默认设置：</span>
                <div class="part3_tab_contentInfo">
                  <div class="part3_tab_InfoBox1">
                    <div class="part3_tab_Box1Item">
                      <div class="part3_tab_ItemCell">
                        <span></span>
                        <span>抽查事项：消防安全检查</span>
                      </div>
                      <div class="part3_tab_ItemCell">
                        <span></span>
                        <span>抽查主体：消防救援总队/支队/大队</span>
                      </div>
                      <div class="part3_tab_ItemCell">
                        <span></span>
                        <span>抽查比例：所有消防安全重点单位</span>
                      </div>
                    </div>
                    <div class="part3_tab_Box1Item">
                      <div class="part3_tab_ItemCell">
                        <span></span>
                        <span>抽查依据：消防监督检查规定（第120号令）</span>
                      </div>
                      <div class="part3_tab_ItemCell">
                        <span></span>
                        <span>抽查对象：消防安全重点单位</span>
                      </div>
                      <div class="part3_tab_ItemCell">
                        <span></span>
                        <span>抽查方式：电脑随机抽查</span>
                      </div>
                    </div>
                  </div>
                  <div class="part3_tab_InfoBox2">
                    <div class="part3_tab_ItemCell">
                      <span></span>
                      <span>抽查次数：每个重点单位每年至少抽查2次，每次时间间隔不低于2个月</span>
                    </div>
                    <div class="part3_tab_ItemCell">
                      <span></span>
                      <span>抽查内容及要求：相关单位是否按照《消防法》、《机关、团体、企业、事业单位消防安全    管理规定》、《省消防条例》相关规定落实各项消防安全主体责任。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img src="static/image/dR_part3bg1.png" alt="">
            </div>
          </div>
          <div class="part3_tab_content" v-show="isActive == 2">
            <div class="part3_tab_contentTxt1">
              分别指单位检查库和执法人员库。检查对象库是指用于随机抽查的对象库；执法人员库是指用于随机选派的消防监督检查人员库
            </div>
            <div>
              <img src="static/image/dR_part3bg2.png" alt="">
            </div>
          </div>
          <div class="part3_tab_content" v-show="isActive == 3">
            <div>
              <div class="part3_tab_contentTxt1">
                指随机抽查细则；即针对随机抽查事例清单的具体实施细则，明确双随机抽查任务产生的时间、抽查对象的类别、抽查的数量、时间间隔和选派执法监督人员，以及检查依据等。
              </div>
              <div>
                <span class="part3_tab_contentTxt2">默认随机抽查规则：</span>
                <div class="part3_tab_contentInfo">
                  <div class="part3_tab_InfoBox2">
                    <div class="part3_tab_ItemCell">
                      <span></span>
                      <span>每月最后天上午十点系统自主随机抽取消防安全重点单位名录并为每个抽取的消防安全重点单位随机选派消防监督检查人员。并生成随机抽查任务清单。</span>
                    </div>
                    <div class="part3_tab_ItemCell">
                      <span></span>
                      <span>随机抽查的检查对象为消防安全重点单位；</span>
                    </div>
                    <div class="part3_tab_ItemCell">
                      <span></span>
                      <span>不区分单位属性类型地随机抽查消防安全重点单位，每个消防安全重点单位平均每六个月抽查一次，且最小抽查间隔不低于2个月；</span>
                    </div>
                    <div class="part3_tab_ItemCell">
                      <span></span>
                      <span>每次随机选派的监督检察人员由一个主查人员和一个协查人员组成检查小组；</span>
                    </div>
                    <div class="part3_tab_ItemCell">
                      <span></span>
                      <span>每个监督执法人员都有公平的机会做主查人员和协查人员。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img src="static/image/dR_part3bg3.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part4_header">
          <span class="part2_header_txt1">客户案例</span>
          <span class="part4_header_txt1">全面推开将为科学高效监管提供新思路</span>
        </div>
        <div class="part3_tab_contentTxt1">
          “双随机、一公开”消防监管信息系统，已经与2019年5月9日试点单位上线使用：部级本级、总队级、支队级、大队级四级部署。
        </div>
        <div>
          <img src="static/image/dRpart4bg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part5_content_box1">
          <img src="static/image/dRpart4bg2.png" alt="">
        </div>
        <div class="part5_content_box2">
          <div class="part5_box2_txtBox">
            <span class="part5_box2_square1"></span><span class="part5_box2_txtTitle1">一类总队</span>
            <div class="part5_box2_txtInfo">
              <div>
                <span>北京总队及所属全部支队</span>
                <span>上海总队及所属全部支队</span>
                <span>河北总队及石家庄支队</span>
                <span>辽宁总队及大连支队</span>
                <span>广东总队及深圳支队</span>
                <span>四川总队及成都支队</span>
                <span>黑龙江总队及齐齐哈尔支队</span>
              </div>
              <div>
                <span>江苏总队及南京支队</span>
                <span>浙江总队及杭州支队</span>
                <span>江西总队及南昌支队</span>
                <span>山东总队及济南支队</span>
                <span>河南总队及郑州支队</span>
                <span>湖北总队及武汉支队</span>
                <span>湖南总队及株洲支队</span>
              </div>
            </div>
          </div>
          <div class="part5_box2_txtBox">
            <span class="part5_box2_square2"></span><span class="part5_box2_txtTitle1">二类总队</span>
            <div class="part5_box2_txtInfo">
              <div>
                <span>天津总队及南开支队</span>
                <span>安徽总队及芜湖支队</span>
                <span>福建总队及福州支队</span>
                <span>甘肃总队及兰州支队</span>
                <span>广西总队及来宾支队</span>
                <span>贵州总队及贵阳支队</span>
                <span>吉林总队及长春支队</span>
              </div>
              <div>
                <span>内蒙总队及巴彦淖尔支队</span>
                <span>山西总队及太原支队</span>
                <span>陕西总队及宝鸡支队</span>
                <span>新疆总队及伊犁支队</span>
                <span>云南总队及昆明支队</span>
                <span>重庆总队及江北支队</span>
              </div>
            </div>
          </div>
          <div class="part5_box2_txtBox">
            <span class="part5_box2_square3"></span><span class="part5_box2_txtTitle1">二类总队</span>
            <div class="part5_box2_txtInfo">
              <div>
                <span>海南总队及三亚支队</span>
                <span>西藏总队及拉萨支队</span>
              </div>
              <div>
                <span>青海总队及西宁支队</span>
                <span>宁夏总队及吴忠支队</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>
</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
    export default {
        name: "doubleRandom",
      components: {HeaderCom, FooterCom,RegisterCom},
      data(){
          return{
            isActive:1,

          }
      },
      methods: {
        handleClick(index) {
          this.isActive = index;
        }
      }
    }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .part1_content{
    width: 1200px;
    height: 630px;
    box-sizing: border-box;
    padding: 60px 0 0 0;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 80px 0;
  }
  .part1_section{
    width: 100%;
    height: 300px;
    box-sizing: border-box;
    display: flex;
  }
  .part1_section>div:nth-of-type(1){
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(2){
    width:30px;
    height:3px;
    background:rgba(42,98,255,1);
    box-sizing: border-box;
    margin: 30px 0;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(3){
    width: 519px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
  }
  .part1_section>div:nth-of-type(2){
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: right;
  }
  .part2Box{
    width:100%;
    height:900px;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part2_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part2_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 65px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part4_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .part2_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part2_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part2_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part3Box,.part4Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
  }
  .part3_content{
    width: 1200px;
    box-sizing: border-box;
    padding:0 0 60px 0;
  }
  .part3_tabs{
    width: 100%;
    box-sizing: border-box;
    padding: 0 100px;
    border-bottom: 1px solid rgba(228,228,228,0.99);
    display: flex;
  }
  .part3_tab1{
    flex: 1;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    box-sizing: border-box;
    padding: 20px 0;
    position: relative;
    cursor: pointer;
  }
  .activeTab{
    color: #2A62FF;
  }
  .activeLine{
    position: absolute;
    width:60px;
    height:2px;
    background:rgba(42,98,255,1);
    bottom: -2px;
    left: 20%;
  }
  .part3_tab_content{
    width: 100%;
    box-sizing: border-box;
    padding: 0 100px;
  }
  .part3_tab_contentTxt1{
    width: 100%;
    box-sizing: border-box;
    padding: 45px 0;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height: 30px;
  }
  .part3_tab_contentTxt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
    display: inline-block;
    box-sizing: border-box;
  }
  .part3_tab_contentInfo{
    width: 100%;
    box-sizing: border-box;
    padding: 15px 0 30px 0;
  }
  .part3_tab_InfoBox1{
    width: 100%;
    box-sizing: border-box;
    display: flex;
  }
  .part3_tab_Box1Item{
    flex: 1;
  }
  .part3_tab_ItemCell{
    display: flex;
    /*align-items: center;*/
    box-sizing: border-box;
    /*padding: 0 0 15px 0;*/
  }
  .part3_tab_ItemCell>span:nth-of-type(1){
    width:10px;
    height:10px;
    border:2px solid rgba(42,98,255,1);
    border-radius:50%;
    margin: 11px 10px 0 0;
  }
  .part3_tab_ItemCell>span:nth-of-type(2){
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height: 30px;
  }
  .part4_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 0 100px;
  }
  .part4_header_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 25px 0;
  }
  .part5Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:rgba(18,29,61,1);
  }
  .part5_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 70px;
    display: flex;
  }
  .part5_content_box1{
    flex: 1;
  }
  .part5_content_box2{
    width: 340px;
  }
  .part5_box2_txtBox{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part5_box2_square1{
    display: inline-block;
    width:10px;
    height:10px;
    background:rgba(255,255,0,1);
    border-radius:2px;
    margin:0 10px 0 0;
  }
  .part5_box2_square2{
    display: inline-block;
    margin:0 10px 0 0;
    width:10px;
    height:10px;
    background:rgba(0,255,138,1);
    border-radius:2px;
  }
  .part5_box2_square3{
    display: inline-block;
    margin:0 10px 0 0;
    width:10px;
    height:10px;
    background:rgba(255,108,0,1);
    border-radius:2px;
  }
  .part5_box2_txtTitle1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:30px;
  }
  .part5_box2_txtInfo{
    width: 100%;
    box-sizing: border-box;
    padding: 0 0 0 20px;
    display: flex;
  }
  .part5_box2_txtInfo>div{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .part5_box2_txtInfo>div>span{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(195,206,234,1);
    line-height:22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/info/doubleRandom.vue